import map from 'lodash/map';
import React, {
  useCallback,
  useEffect,
  useState
} from 'react';


import InPageSearchDisplayUI from './in_page_search_display_ui.jsx';


const itemToIdent = (item)=>
  `${item.type}::${item.uuid||item.id}`;

const mapResultSet = (searchResults) => {
  const resultSet = map(searchResults,
    (res) =>
      ({
        ident: itemToIdent(res),
        identifyingField: res.identifyingField,
        matches: res.matches,
        meta: res.meta,
        score: res.score
      })
  );

  return resultSet;
};

export const InPageSearchDisplay = ({
  search,
  searchIndex,
  onClose,
  onSearchResultClick,
  onSearchChange
}) => {

  const [searchResults, updateSearchResults] = useState([]);
  const mappedResultSet = mapResultSet(searchResults);

  const handleKeydown = useCallback((e) => {
    if (e.keyCode == 27) { // ESC
      onClose();
    }
  });


  const runSearch = (searchText) => {
    const resultsSet = searchIndex.search(searchText);
    updateSearchResults(resultsSet);
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeydown, false);
    runSearch(search);

    return () => {
      // return cleanup function
      document.removeEventListener('keydown', handleKeydown, false);
    };
    // run once on initial render
  }, []);

  useEffect(() => {
    runSearch(search);
    // Only run when the `search` value changes
    // so we don't continously trigger re-renders
  }, [search]);

  return (
    <InPageSearchDisplayUI 
      search={search}
      results={mappedResultSet}
      onResultChoose={(ident)=> {
        onSearchResultClick(ident);
        onClose();
      }}
      onSearchChange={onSearchChange}
      onClose={onClose}
    />
  );
};

export default InPageSearchDisplay;